import React from "react";

export const customNumberInputHandler = (
    integerLimit: number,
    decimalLimit: number,
    maxValue?: number // Optional max value
) => {
    return (e: React.KeyboardEvent<HTMLInputElement>) => {
        const input = e.target as HTMLInputElement;
        let value = input.value;
        const cursorPosition = input.selectionStart || 0; // Handle null case

        // Calculate default max value if not provided
        const defaultMaxValue = parseFloat("9".repeat(integerLimit) + "." + "9".repeat(decimalLimit)) || 0;
        const maxAllowed = maxValue !== undefined ? maxValue : defaultMaxValue;

        // Define allowed keys: Digits 0-9, ".", and special keys
        const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "."];

        // Disable pasting
        input.onpaste = (event) => {
            event.preventDefault();
        };

        // Allow digits (0-9) and special keys
        if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
            e.preventDefault();
            return;
        }

        // Allow special keys (Backspace, Delete, Arrow keys, Tab)
        if (["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)) {
            return;
        }

        // Allow only one decimal point
        if (e.key === ".") {
            if (!value || value.includes(".")) {
                e.preventDefault();
            }
            return;
        }

        // Allow only digits
        if (!/^\d$/.test(e.key)) {
            e.preventDefault();
            return;
        }

        const decimalIndex = value.indexOf(".");
        const parts = value.split(".");
        const integerPart = parts[0] || "";
        const decimalPart = parts[1] || "";

        // **Check if cursor is before or after the decimal**
        const isBeforeDecimal = decimalIndex === -1 || cursorPosition <= decimalIndex;

        // Restrict integer part to integerLimit
        if (isBeforeDecimal && integerPart.length >= integerLimit) {
            e.preventDefault();
            return;
        }

        // Restrict decimal places to decimalLimit (if cursor is after the `.`)
        if (!isBeforeDecimal && decimalPart.length >= decimalLimit) {
            e.preventDefault();
            return;
        }

        // ** Fix: Correctly insert character at cursor position **
        const newValue =
            value.substring(0, cursorPosition) + e.key + value.substring(cursorPosition);

        // Ensure value does not exceed maxAllowed
        if (parseFloat(newValue) > maxAllowed) {
            e.preventDefault();
            return;
        }
    };
};
